"use strict";
/**
 * Re-export Public interfaces
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.UCMC_CONNECTION_NAME = exports.INTEGRATIONS = exports.CONTEXTS = void 0;
var constants_1 = require("./common/constants");
__createBinding(exports, constants_1, "CONTEXT_TYPES", "CONTEXTS");
__createBinding(exports, constants_1, "INTEGRATION_TYPES", "INTEGRATIONS");
__createBinding(exports, constants_1, "SDS_CONNECTION_NAME", "UCMC_CONNECTION_NAME");
